// src/pages/SearchPage.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function SearchPage() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const allResults = state?.results || [];
    const filters = state?.filters || {};

    // Şehre ve ilçeye göre filtreleme
    const filteredResults = allResults.filter((place) => {
        const cityName = typeof place.city === 'object' ? place.city?.name?.toLowerCase() : place.city?.toLowerCase();
        const townName = typeof place.town === 'object' ? place.town?.name?.toLowerCase() : place.town?.toLowerCase();
        return (
            cityName === filters.province?.toLowerCase() &&
            townName === filters.district?.toLowerCase()
        );
    });

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col">
            <section className="p-8">
                <h2 className="text-2xl font-bold text-center mb-8">Arama Sonuçları</h2>

                {filteredResults.length === 0 ? (
                    <p className="text-center text-gray-500">Sonuç bulunamadı.</p>
                ) : (
                    <div className="max-w-6xl mx-auto grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                        {filteredResults.map((place) => (
                            <div
                                key={place.uid}
                                className="group relative bg-white rounded-lg shadow-lg overflow-hidden flex flex-col cursor-pointer hover:scale-105 transform transition"
                                onClick={() => navigate(`/hostel/${place.uid}`)}
                            >
                                <img
                                    src={
                                        place.image ||
                                        'https://via.placeholder.com/400x250?text=Resim+Yok'
                                    }
                                    alt={place.name}
                                    className="w-full h-48 object-cover group-hover:opacity-80 transition"
                                />
                                <div className="p-4 flex-1 flex flex-col">
                                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                                        {place.name}
                                    </h3>
                                    <p className="text-gray-600 text-sm mb-2">
                                        {(typeof place.city === 'object' ? place.city?.name : place.city) || 'Şehir bilgisi yok'} /{' '}
                                        {(typeof place.town === 'object' ? place.town?.name : place.town) || 'İlçe bilgisi yok'}
                                    </p>
                                    <p className="text-gray-600 text-sm flex-1">
                                        {(typeof place.village === 'object' ? place.village?.name : place.village) || 'Köy bilgisi yok'}
                                    </p>
                                    <div className="mt-auto text-indigo-600 font-semibold">
                                        {place.price ? `₺${place.price} / Gece` : ''}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
